import React, {useState} from "react";
import "./PaginatorStyle.sass"
const Paginator = ({totalCount, activePage, setActivePage, pageSize, countPagesInPortion}) => {

    const [portionNumber, setPortionNumber] = useState(1);
    const allPages = Math.ceil(totalCount/pageSize);
    const leftBorderPortion = (portionNumber - 1) * countPagesInPortion + 1;
    const rightBorderPortion = portionNumber * countPagesInPortion;
    let arrPage = [];
    for (let i = 1; i <= allPages; i++)
        arrPage.push(i);

    return(
        <div className="paginator">
            <div className='paginator__button'>{portionNumber > 1 ? <button onClick={() => setPortionNumber(portionNumber - 1)}>«</button> : null}</div>
            {arrPage.filter(page => page <= rightBorderPortion && page >= leftBorderPortion).map(page =>
                <div key={page} className={activePage === page ? "paginator__active-page paginator__button" : "paginator__button"}>
                    <button onClick={() => setActivePage(page)}>{page}</button>
                </div>)
            }
            <div className='paginator__button'>{rightBorderPortion < allPages ? <button onClick={() => setPortionNumber(portionNumber + 1)}>»</button> : null}</div>
        </div>
    )
};

export default Paginator